enum RouteName {
    EVENT_LIVE_MANUAL_LOGIN = 'event-live-manual-login',
    NETWORKING_ROOM = 'networking-room',
    ROOM_CONFERENCE = 'room-conference',
    EVENTS = 'events',
    APP = 'app',
    LOGIN_AND_REDIRECT = 'login-and-redirect',
    EVENTS_LIVE_AND_REPLAY = 'events-live-and-replay',
    EVENTS_VIDEO = 'events-video',
    EVENT_LIVE_STAGE = 'event-live-stage',
    EVENT_LIVE_NETWORKING = 'event-live-networking',
    EVENT_LIVE_SCHEDULE = 'event-live-schedule',
    EVENT_LIVE_MAGIC_LINK = 'event-live-magic-link',
    EVENT_BACKSTAGE_MAGIC_LINK = 'event-backstage-magic-link',
    EVENT = 'event',
    EVENT_REPLAY = 'event-replay',
    EVENT_BACKSTAGE = 'event-backstage',
    EVENT_LIVE = 'event-live',
    PUBLIC_EVENT = 'public-event',
    MEMBER = 'member',
    MEMBER_ME = 'member-me',
    MEMBER_DETAILS = 'member-details',
    MEMBER_AGREEMENT = 'member-agreement',
    MEMBER_AGREEMENT_ME = 'member-agreement_me',
    MEMBER_AGREEMENT_HISTORY = 'member-agreement-history',
    MEMBER_BUSINESS_NEEDS = 'member-business-needs',
    MEMBER_PREFERENCES = 'member-preferences',
    MEMBER_LIST_ALL = 'member-list-all',
    MEMBER_LIST_CONTACTS = 'member-list-contacts',
    MEMBER_LIST_FAVORITES = 'member-list-favorites',
    MEMBER_LIST_SUGGESTIONS = 'member-list-suggestions',
    MEMBER_RECOMMEND = 'member-recommend',
    MEMBERSHIP = 'membership',
    PUBLIC_CGV = 'public-cgv',
    CONTACT = 'contact',
    TEST = 'test',
    DEVTEST_LOGIN = 'devtest',
    PUBLIC_TEST = 'public-test',
    SEARCH_SEARCH_ALL = 'search-search-all',
    BENEFITS = 'benefits',
    BENEFITS_CATEGORY = 'benefits-category',
    BENEFITS_SINGLE = 'benefits-single',
    BENEFITS_FAVORITES = 'benefits-favorites',
    WORKSPACES = 'workspaces',
    CLUB_SINGLE = 'club-single',
    CLUB_SINGLE_CHAT = 'club-single-chat',
    CLUB_SINGLE_MEMBERS = 'club-single-members',
    CLUB_SINGLE_BOARD = 'club-single-insiders',
    CLUB_SINGLE_MARKETPLACE_PROJECTS = 'club-single--marketplace-projects',
    CLUB_SINGLE_STRUCTURED_PROJECTS = 'club-single--structured-projects',
    CLUB_SINGLE_PROJECTS = 'club-single--projects',
    CLUB_SINGLE_PROJECT_SINGLE = 'club-single-project-single',
    CLUB_SINGLE_EVENTS = 'club-single-events',
    CLUB_SINGLE_SOLUTIONS_AND_SERVICES = 'club-single-solutions',
    CLUB_SINGLE_NEWS = 'club-single-news',
    CLUB_SINGLE_RULES = 'club-single-rules',
    CLUB_SINGLE_VIDEOS = 'club-single-videos',
    CLUB_SINGLE_JOIN = 'club-single-join',
    HUB_SINGLE = 'hub-single',
    HUB_SINGLE_CHAT = 'hub-single-chat',
    HUB_SINGLE_MEMBERS = 'hub-single-members',
    HUB_SINGLE_EVENTS = 'hub-single-events',
    TRIP_PLANNER_ADD = 'trip-planner-add',
    TRIP_PLANNER_LIST = 'trip-planner-list',
    TRIP_PLANNER_SINGLE = 'trip-planner-single',
    LOGIN = 'login',
    REGISTER = 'register',
    UPDATE_ACCOUNT = 'update-account',
    UPDATE_ACCOUNT_PASSWORD = 'update-account-password',
    PASSWORD_FORGOT = 'password-forgot',
    RESET_PASSWORD = 'reset-password',
    LOGOUT = 'logout',
    APPLY_ROOT = 'apply',
    APPLY = 'apply-contact',
    APPLY_MEMBERSHIP = 'apply-membership',
    APPLY_DETAILS = 'apply-details',
    APPLY_VALIDATION = 'apply-validation',
    APPLY_FINISHED = 'apply-finished',
    COMMUNITY_APPLY = 'community-apply',
    COMMUNITY_APPLY_MEMBERSHIP = 'community-apply-membership',
    COMMUNITY_APPLY_VALIDATION = 'community-apply-validation',
    COMMUNITY_APPLY_PAYMENT = 'community-apply-payment',
    COMMUNITY_APPLY_FINISHED = 'community-apply-finished',
    UNSUBSCRIBE = 'unsubscribe',
    NFT_MEMBER_2022 = 'nft-member-2022',
    NFT_TOUR = 'nft-tour',
    NFT = 'nft',
    NFT_HOME = 'nft-home',
    NFT_HELP = 'nft-help',
    NFT_WALLET = 'nft-wallet',
    NFT_EVENTS = 'nft-events',
    TEAM_PAGE = 'team-page',
    ARTICLES = 'articles-page',
    ARTICLE_PAGE = 'article-page',
    HOME = 'home',
    SWITCH_TO = 'switch-to',
    COMPANY = 'company',
}

export default RouteName
